import React, { useContext, useEffect, useState } from 'react';

import { PagePropsContext } from '../App';
import { getCategoriesEllipsis } from '../utils/functions';

const CategoryCard = ({
  category,
  icon = '',
  isExpanded = false
}) => {
  const { categories, setSelectedCategory } = useContext(PagePropsContext);

  const [isActive, setIsActive] = useState(false);
  const [children, setChildren] = useState([]);

  useEffect(() => {
    setChildren(categories.filter(cat => cat.parent_category === category.id));
  }, [categories, category]);

  // Actions
  const toggleActive = () => {
    if (isExpanded) { return; }
    setIsActive(!isActive);
  };

  const handleClick = (e, cat) => {
    e.stopPropagation();
    setSelectedCategory(cat);
  };

  return <div
    className={`category-card${isActive ? ' card--active' : ''}${isExpanded ? ' card--expanded' : ''}`}
    onClick={toggleActive}
  >
    <div className='category-card__icon'><i className={`icon icon--${icon}`}></i></div>
    <div className='category-card__content'>
      <h3 className='category-card__title'>{category.name}</h3>
      {children.length > 0 && <p className='category-card__ellipsis'>{getCategoriesEllipsis(children)}</p>}
      {children.length > 0 && <ul className='category-card__list'>
        {children.map(cat => <li key={cat.id} className='category-card__item' onClick={(e) => handleClick(e, cat)}>
          {cat.name}
        </li>)}
      </ul>}
    </div>
  </div>;
}

export default CategoryCard;